import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewerAsset } from '@models/viewer-asset';
import { DrawingColors, DrawingBrushSizes, DrawingTools } from '@shared/drawing/drawing';
import { Subject } from 'rxjs';

@Component({
  template: `<div></div>`,
  standalone: false
})
export abstract class ViewerBaseComponent {
  @Input() asset: ViewerAsset;
  @Input() series: string;
  @Input() grade: string;
  @Input() selectedTool: DrawingTools = DrawingTools.none;
  @Input() drawingColor: DrawingColors = DrawingColors.black;
  @Input() brushSize: DrawingBrushSizes = DrawingBrushSizes.med;
  @Input() zoomLevel = 100;
  @Input() clearClicked: Subject<void>;
  @Output() loaded: EventEmitter<void> = new EventEmitter<void>();
  @Output() withError: EventEmitter<any> = new EventEmitter<any>();
  @Output() completed: EventEmitter<void> = new EventEmitter<void>();
}
